import axios from 'axios';
import { useEffect, useState } from 'react';
import { API_URL } from '../constants/Globals';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { fetchAiRequestLimitExceedStatus, fetchAiResponseLimitExceedStatus, fetchClientSubscriptionStatus } from '../services/SubscriptionSvc';
import { getClientOrganization } from '../services/NetworkSvc';

const SubscriptionExpiredBanner = ({ networkId }) => {
  const [visible, setVisible] = useState(false);
  const [isAiReqExceed, setIsAiReqExceed] = useState(false);
  const [isAiRespExceed, setIsAiRespExceed] = useState(false);
  const [groupId, setGroupId] = useState(0);

  const isSubscriptionExpired = async () => {
    const subscStatus = await fetchClientSubscriptionStatus(networkId);
    if (!subscStatus) {
      setVisible(true);
    }
  }

  const getClientOrganizationId = async() => {
    const groupId = await getClientOrganization(networkId);
    setGroupId(groupId);
  }

  useEffect(() => {
    if (networkId && networkId != null) {
      getClientOrganizationId();
      isSubscriptionExpired();
      
    }
  }, [networkId]);

  const isAiResponseLimitExceed = async () => {
    const isAiRespLimitExceed = await fetchAiResponseLimitExceedStatus(groupId);
    if (isAiRespLimitExceed) {
      setIsAiRespExceed(true);
    }
  }

  const isAiRequestLimitExceed = async () => {
    const isAiReqLimitExceed = await fetchAiRequestLimitExceedStatus(groupId);
    if (isAiReqLimitExceed) {
      setIsAiReqExceed(true);
    }
  }

  useEffect(() => {
    if (groupId) {
      isAiResponseLimitExceed();
      isAiRequestLimitExceed();
    }
  }, [groupId]);

  // if (!visible) return null;

  return (
    <>
      {(visible || isAiReqExceed || isAiRespExceed) && (
        <div className="expsubsc-banner-wrapper">
          <div className="expsubsc-banner">
            <span className="expsubsc-text">
              {visible && (
                <>
                  <strong>Subscription Expired:</strong> Your subscription has expired.{' '}
                  <NavLink className="expsubsc-link" exact to="/subscription-renew">
                    Please renew your plan here.
                  </NavLink>
                </>
              )}

              {isAiReqExceed && (
                <>
                  {!visible && <strong>Notice:</strong>} You've reached your limit of AI Requests.
                  Please upgrade or wait until limits reset.{' '}
                </>
              )}

              {isAiRespExceed && (
                <>
                  {!visible && !isAiReqExceed && <strong>Notice:</strong>} You've reached your limit
                  for responses. Please upgrade or wait until limits reset.
                </>
              )}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionExpiredBanner;
